<template>
    <div
            class="header-analytics"
            :class="{'header-analytics_small': windowWidth <= 1125}"
    >
        <div class="header-analytics__items">
            <header-analytics-item
                    v-for="(item, index) in headerAnalyticsItems"
                    :key="index"
                    :headerAnalyticsItem="item"
            />
        </div>
        <div class="header-analytics__btn">
            <div
                    v-if="showExport"
                    class="dropdown"
                    :class="{'active': isGroupButtonPushed === true}"
            >
                <button @click="changeGroupButtonFlag()" class="header-analytics__btn_action">Скачать</button>
                <div class="dropdown-menu">
                    <div class="dropdown-menu-wrap">
                        <div class="dropdown-menu-body">
                            <button
                                @click="onClickExportMedia()"
                                class="dropdown-menu-item"
                            >Скачать отчет P&L</button>
                            <button
                                @click="onClickExportMedia(false)"
                                class="dropdown-menu-item"
                            >Скачать отчет P&L без НДС</button>
                            <button
                                    @click="onClickExportTable(false)"
                                    class="dropdown-menu-item"
                            >Скачать аналитику клиентов</button>
                            <button
                                @click="onClickExportTableDetail()"
                                class="dropdown-menu-item"
                            >Скачать отчет о прибылях и убытках с детализациией по клиентам и подрядчикам
                            </button>
                            <button
                                    @click="onClickExportSupplierReport()"
                                    class="dropdown-menu-item"
                            >Скачать отчет по подрядчикам
                            </button>
                            <button
                                    @click="onClickExportPlacements()"
                                    class="dropdown-menu-item"
                            >Скачать конструкции 2021
                            </button>
                            <button
                                @click="onClickExportPlacementsNew()"
                                class="dropdown-menu-item"
                            >Скачать конструкции
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <button
                    v-if="isCreateSlice"
                    class="header-analytics__btn_action"
                    @click="onOpenModal"
            >
                <span>Создать срез</span>
            </button>

        </div>
      <modal
          v-show="isModal"
          @close="closeModal"
      >
        <template v-slot:modalBody>
          <form-create-slice
              v-if="isModal"
              @submitForm="onCreateSlice"
              @cancelForm="closeModal"
          />
        </template>
      </modal>
    </div>
</template>

<script>
import HeaderAnalyticsItem from './HeaderAnalyticsItem';
import mixinAdaptive from '../../../mixins/mixinAdaptive';
import FormCreateSlice from "@/components/Forms/FormCreateSlice";
import Modal from "@/components/Base/Modal";
export default {
    name: 'HeaderAnalytics',
    mixins: [
        mixinAdaptive
    ],
    components: {
      Modal,
      FormCreateSlice,
        HeaderAnalyticsItem
    },
    /**
     * данные компонента
     */
    data: () => ({
        isGroupButtonPushed: false,
        isModal: false
    }),
    /**
     * входные данные компонента
     * @property {array} headerAnalyticsItems - элементы хедера
     * @property {boolean} isCreateSlice - условие создания среза
     */
    props: {
        headerAnalyticsItems: {
            type: Array,
            default: () => ([])
        },
        isCreateSlice: {
            type: Boolean,
            default: false
        },
        showExport:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**
         * событие клика по кнопке создать клиента
         */
        onOpenModal() {
          this.isModal = true;
        },
        /**
         * событие создания среза
         * @property {string} year
         */
        onCreateSlice(year) {
            this.$emit('onCreateSlice', year);
            this.closeModal();
        },
        onClickExportMedia(withTax = true){
          this.changeGroupButtonFlag();
          this.$emit('onClickExportMedia', withTax);
        },
        onClickExportTable(isGroupFlag){
            this.changeGroupButtonFlag();
            this.$emit('onClickExportTable', isGroupFlag);
        },
        onClickExportTableDetail() {
          this.changeGroupButtonFlag();
          this.$emit('onClickExportTableDetail');
        },
        onClickExportSupplierReport() {
            this.$emit('onClickExportSupplierReport');
        },
        onClickExportPlacementsNew(){
          this.changeGroupButtonFlag();
          this.$emit('onClickExportPlacementsNew');
        },
        onClickExportPlacements(){
            this.changeGroupButtonFlag();
            this.$emit('onClickExportPlacements');
        },
        /**
         * toggle выпадающего списка кнопок экспорта
         */
        changeGroupButtonFlag(){
            this.isGroupButtonPushed = !this.isGroupButtonPushed;
        },
        /**
         * событие закрытие модального окна добавления клиента
         */
        closeModal() {
          this.isModal = false;
        },
    }
}
</script>

<style lang="scss" scoped>
    .header-analytics {
        display: flex;
        justify-content: space-between;
        padding: 4px;
        background: #fff;
        border-radius: 100px;
        align-items: center;
    }
    .header-analytics_small {
        border-radius: 14px;
        padding-left: 10px;
        padding-right: 7px;
    }
    .header-analytics__items {
        display: flex;
        flex-wrap: wrap;
    }
    .header-analytics__btn_action {
        border: none;
        cursor: pointer;
        outline: none;
        height: 32px;
        color: #b0b1b4;
        background: transparent;
        border-radius: 100px;
        transition: .3s;
        padding: 0 20px;
        border: 1px solid transparent;
        white-space: nowrap;
    }
    .header-analytics__btn_action:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .dropdown {
        position: relative;
        display: inline-block;
    }
    .dropdown-menu::before {
        content: "";
        position: absolute;
        display: block;
        border: 9px solid transparent;
        border-bottom-color: transparent;
        border-bottom-color: #fff;
        right: 20px;
        top: -16px;
        z-index: 999;
    }
    .dropdown.active .dropdown-menu {
        opacity: 1;
        visibility: visible;
        z-index: 9;
        display: flex;
    }
    .dropdown-menu {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: nowrap;
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 1;
        opacity: 0;
        margin-top: 10px;
        visibility: hidden;
        display: none;
        pointer-events: none;
    }
    .dropdown-menu-wrap {
        min-width: 250px;
        position: relative;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 4px 28px rgba(59,74,116,.15),0 4px 10px rgba(59,74,116,.15);
        overflow: hidden;
        z-index: 100;
        pointer-events: auto;
    }
    .dropdown-menu-body {
        padding: 20px;
        position: relative;
        max-height: 360px;
        overflow-y: auto;
        background: #fff;
    }
    .dropdown-menu-item {
        cursor: pointer;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        position: relative;
        display: flex;
        padding: 0 30px 0 15px;
        height: 36px;
        border-radius: 36px;
        width: 100%;
        white-space: nowrap;
        line-height: 1;
        align-items: center;
        transition: all 150ms;
    }
    .dropdown-menu-item:hover{
        background: #F5F5F5F5;
    }
    .view-analytics-clients__export-btn{
        cursor: pointer;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
</style>